// Live polling options (architecture sprint-04 §5.1, S5.8). Only while the tab is visible; the timer
// query overrides refetchIntervalInBackground so hidden tabs still notice a stop elsewhere.
import { LIVE_REFETCH_MS } from '@shared/report-rules';

const LIVE_STALE_MS = 5_000;

export const LIVE_QUERY_OPTIONS = {
  refetchInterval: LIVE_REFETCH_MS,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: true,
  staleTime: LIVE_STALE_MS,
} as const;
